import { BaseUiItem, UiGroup } from '../ui-form';
import { AbstractControl } from '@angular/forms';
import { MngDialogService } from '../../dialog/mng-dialog.service';
import { DIALOG_DATEN_INVALID_OPTIONS, DIALOG_DATEN_NOT_DIRTY_OPTIONS } from '../../dialog/mng-dialog-util';

export function findInputElement(basisElement: HTMLElement): HTMLElement {
  let element: HTMLElement = basisElement;
  if (basisElement.tagName !== 'input' && basisElement.tagName !== 'textarea') {
    // wenn das Element KEIN input element ist
    // dann versuche ein input Element für dieses Element zu finden
    let inputElements: HTMLCollectionOf<Element> = basisElement.getElementsByTagName('input');
    if (inputElements.length > 0) {
      element = <HTMLElement>inputElements.item(0);
    } else {
      // kein input element gefunden ->  versuche jetzt textarea zu finden
      inputElements = basisElement.getElementsByTagName('textarea');
      if (inputElements.length > 0) {
        element = <HTMLElement>inputElements.item(0);
      } else {
        // kein input element gefunden ->  versuche jetzt textarea zu finden
        inputElements = basisElement.getElementsByTagName('mat-select');
        if (inputElements.length > 0) {
          element = <HTMLElement>inputElements.item(0);
        }
      }
    }
  }
  return element;
}

export function uiOkCheck(
  uiItem: BaseUiItem<AbstractControl>,
  dialogService: MngDialogService,
  dirtyCheck = true,
  validCheck = true,
  customValidCheck: () => boolean = () => true
): boolean {
  if (dirtyCheck && !uiItem.control.dirty) {
    dialogService.showOK(DIALOG_DATEN_NOT_DIRTY_OPTIONS);
    return false;
  }

  if (validCheck && (!uiItem.control.valid || !customValidCheck())) {
    dialogService.showOK(DIALOG_DATEN_INVALID_OPTIONS);

    if (uiItem instanceof UiGroup) {
      // Achtung -> dadurch werde auch etwaige valueChanges ausgelöst
      uiItem.markAllFieldsAsTouchedAndUpdateValueAndValidity();
    } else {
      uiItem.control.markAllAsTouched();
    }

    return false;
  }

  return true;
}
